import { render, staticRenderFns } from "./operationrecord.vue?vue&type=template&id=9a667572&scoped=true&"
import script from "./operationrecord.vue?vue&type=script&lang=js&"
export * from "./operationrecord.vue?vue&type=script&lang=js&"
import style0 from "./operationrecord.vue?vue&type=style&index=0&id=9a667572&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a667572",
  null
  
)

export default component.exports